//TODO: not sure we need this anymore, since there exist alternatives ?

import isUndefined from "lodash/isUndefined";
import isFunction from "lodash/isFunction";
import isNull from "lodash/isNull";
import isDate from "lodash/isDate";
import isObject from "lodash/isObject";
import isArray from "lodash/isArray";
import each from "lodash/each";
import isString from "lodash/isString";
import reject from "lodash/reject";
import clone from "lodash/clone";

export function deepExtend(obj: object, ...extendWith: object[]) {
    const parentRE = /#{\s*?_\s*?}/;

    each(extendWith, function (source) {
        for (const prop in source) {
            if (
                isUndefined(obj[prop]) ||
                isFunction(obj[prop]) ||
                isNull(source[prop]) ||
                isDate(source[prop])
            ) {
                obj[prop] = source[prop];
            } else if (isString(source[prop]) && parentRE.test(source[prop])) {
                if (isString(obj[prop])) {
                    obj[prop] = source[prop].replace(parentRE, obj[prop]);
                }
            } else if (isArray(obj[prop]) || isArray(source[prop])) {
                if (!isArray(obj[prop]) || !isArray(source[prop])) {
                    throw new Error(
                        `Trying to combine an array with a non-array (${prop})`
                    );
                } else {
                    obj[prop] = reject(
                        deepExtend(clone(obj[prop]), source[prop]),
                        function (item) {
                            return isNull(item);
                        }
                    );
                }
            } else if (isObject(obj[prop]) || isObject(source[prop])) {
                if (!isObject(obj[prop]) || !isObject(source[prop])) {
                    throw new Error(
                        `Trying to combine an object with a non-object (${prop})`
                    );
                } else {
                    obj[prop] = deepExtend(clone(obj[prop]), source[prop]);
                }
            } else {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
}
